export default __webpack_public_path__ + "static/media/pendingCheck.b2487be6.svg";